import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { AppBar, Drawer, Fade, useMediaQuery, SvgIcon, Toolbar, Dialog, Box, Button, Container, Stack, Divider, Grid, Typography, IconButton, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from 'components/snackbar';
import { useAuth } from 'hooks/useAuthContext';

import { getBasicProfileDetails, getAllEducationDetails, getAllCertificationDetails, updateUser, updateMainResume, setTemplate, getResumeUrl, getTemplate } from 'api/users';

import { SplashScreen } from 'components/loading-screen';

import ContactDetails from 'components/basic-profile/ContactDetails';
import PersonalDetails from 'components/basic-profile/PersonalDetails';
import CertificationSection from 'components/basic-profile/CertificationSection';
import WorkExperienceDetails from 'components/basic-profile/WorkExperienceSection';
import ProfessionalSummary from 'components/basic-profile/ProfessionalSummary';
import CustomSection from 'components/basic-profile/CustomSection';
import UploadProfile from 'components/basic-profile/UploadProfile';
import CandidateResume from 'components/basic-profile/CandidateResume';
import FinanceTechnicalCompetencies from 'components/basic-profile/FinanceTechnicalCompetencies';
import Disability from 'components/basic-profile/Disability';
import CareerBreaksIdentifiedDialog from 'components/basic-profile/CareerBreaksIdentifiedDialog';
import IncompleteSectionDialog from 'components/basic-profile/IncompleteSectionDialog';
import UploadExistingProfile from 'components/basic-profile/UploadExistingProfile';
import TotalWorkExperienceDisplay from 'components/basic-profile/TotalWorkExperienceDisplay';
import EducationDetails from '../../components/basic-profile/EducationSection';
import LeaveWithoutUpdatingDialog from 'components/basic-profile/LeaveWithoutUpdatingDialog';
import { useBackNavigationDialog } from 'hooks/useBackNavigationDialog';


// Dialog transition component
const Transition = forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});



const RegistrationUploadResume = () => {
    const location = useLocation();
    const theme = useTheme();
    const [profile, setProfile] = useState();
    const [educationData, setEducationData] = useState([]);
    const [workExperienceData, setWorkHistory] = useState();
    const personalDetailRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [alignment, setAlignment] = useState('using-existing-resume');
    const [profilephoto, setProfilePhoto] = useState([]);
    const [contactDetailsError, setContactDetailsError] = useState();
    const [expandedSection, setExpandedSection] = useState({ section: null, index: null });
    const { enqueueSnackbar } = useSnackbar();
    const [certificateData, setCertificate] = useState();
    const [financeTechologiesData, setfinanceTechologiesData] = useState([]);
    const [summaryData, setSummary] = useState();
    const [templateType, setTemplateType] = useState('');
    const [customSection, setCustomSection] = useState([]);
    const [loading, setLoading] = useState(true);
    const [flag, setFlag] = useState(true);
    const [nextPage, setNextPage] = useState(false);
    const { user, updateContext } = useAuth();
    const navigate = useNavigate();
    const [workExperienceGap, setGap] = useState([]);
    const { uploadResume, createNewResume } = location.state || { uploadResume: false, createNewResume: false };
    const [withoutUpdateDialog, setLeaveWihoutUpdatingDialog] = useState(false);
    const [loads, setloads] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [resume, setResume] = useState('');
    const scrollableContainerRef = useRef(null);
    const [showFirstButton, setShowFirstButton] = useState(true);
    // const [previewResume, setPreviewRsume] = useState(false);
    const [openIncompleteDialog, setOpenIncompleteDialog] = useState(false);

    useEffect(() => {
        fetchData();
        fetchTemplate();
    }, []);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowFirstButton(false);
        }, 10000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        setExpandedSection({ section: null, index: null });
    }, [user]);
    /**
     * Fetches the resume template for the candidate.
     * If the response is successful and contains data, updates the alignment
     * state based on whether the candidate's resume is a master resume or an
     * existing template. Logs any errors encountered during the fetch process.
     */

    const fetchTemplate = async () => {
        try {
            const response = await getTemplate();
            if (response?.success && response.data) {
                const candidate = response?.data;
                setAlignment(
                    candidate?.is_master_resume
                        ? 'talent-juntion-style'
                        : candidate?.template || 'using-existing-resume'
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    /**
     * Resets the expanded section state to null when the profile photo changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after editing the profile photo.
     * @param {string} resumeLink - The new resume link to set in component state.
     */
    const handleProfilePhotoChange = (resumeLink) => {
        if (resumeLink) {
            setResume(resumeLink);
        }
        fetchData();
        setExpandedSection({ section: null, index: null });
    };
    /**
     * Handles changes to the ToggleButtonGroup.
     * Updates the alignment state with the new alignment value and sends a request
     * to set the template on the server. Logs the server response or any errors encountered.
     * @param {React.ChangeEvent<HTMLInputElement>} event - The event from the ToggleButtonGroup.
     * @param {string} newAlignment - The new alignment value from the ToggleButtonGroup.
     */

    const handleToggleChange = async (event, newAlignment) => {
        if (!newAlignment) return;

        try {
            setAlignment(newAlignment);
            const response = await setTemplate({ data: newAlignment });
            console.log('Template set response:', response);
        } catch (error) {
            console.error('Failed to set template:', error);
        }
    };

    /**
     * Checks if the given data object is empty.
     * A value is considered empty if it is null, undefined, an empty string, or an empty array.
     * @param {object} data - The data object to check
     * @returns {boolean} True if the data object is empty, false otherwise
     */
    const checkLocalDataIsEmpty = (data) => {
        if (data) {
            return Object.values(data)?.every(value =>
                value === null ||
                value === undefined ||
                (typeof value === 'string' && value.trim() === '') ||
                (Array.isArray(value) && value.length === 0)
            );
        }
    };

    /**
     * Fetches the candidate's profile, education, work history, and certifications data from the server.
     * If the data is successfully fetched, updates the component state with the fetched data.
     * If there is an error, logs the error in the console and set the updating state to false.
     * Finally, sets the loading state to false.
     */
    const fetchData = async () => {
        try {
            setUpdating(true);
            const [profileResponse, educationAndWorkResponse, certificateResponse] = await Promise.all([
                getBasicProfileDetails(),
                getAllEducationDetails(),
                getAllCertificationDetails(),
            ]);
            if (profileResponse?.success && profileResponse.data) {
                const profileData = profileResponse.data.candidate ?? {};
                setProfile(profileResponse.data);
                setSummary(profileData.summary || '');
                if (profileData.custom_section) {
                    setCustomSection(profileData.custom_section);
                }
                if (profileData.template) {
                    setTemplateType(profileData.template);
                }
                if (profileData.finance_technologies) {
                    setfinanceTechologiesData(profileData.finance_technologies);
                }
            }
            if (educationAndWorkResponse?.success && educationAndWorkResponse.data) {
                const eduUnsavedData = localStorage.getItem("education") ? JSON.parse(localStorage.getItem("education")) : null;
                const workUnsavedData = localStorage.getItem('workExperience') ? JSON.parse(localStorage.getItem('workExperience')) : null;
                setEducationData([...educationAndWorkResponse.data?.educationList || [], ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])]);
                setWorkHistory([...educationAndWorkResponse.data?.workHistoryList || [], ...(workUnsavedData && !checkLocalDataIsEmpty(workUnsavedData) ? [{ ...workUnsavedData }] : [])]);
            }
            if (certificateResponse?.success && certificateResponse.data) {
                const certificateUnsavedData = localStorage.getItem("certificate") ? JSON.parse(localStorage.getItem("certificate")) : null;
                setCertificate([...certificateResponse.data || [], ...(certificateUnsavedData && !checkLocalDataIsEmpty(certificateUnsavedData) ? [{ ...certificateUnsavedData }] : [])]);
            }
            const workGapList = educationAndWorkResponse?.data?.workHistoryList.filter(edu => edu?.organization_name == 'Work Gap');
            if (workGapList?.length > 0) {
                const filterWithoutReason = workGapList.filter(edu => !edu?.gap_explaination || !edu?.gap_title);
                if (filterWithoutReason?.length > 0) {
                    setOpen(true);
                    setGap(filterWithoutReason);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setUpdating(false);
        } finally {
            setLoading(false);
        }
    };

    /**
     * Resets the expanded section state to null when the education data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing an education.
     * Also, refetches the data from the server to reflect the changes.
     */
    const handleEducationDataChange = () => {
        setExpandedSection({ section: null, index: null });
        fetchData();
    };

    /**
     * Resets the expanded section state to null when the work experience data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing a work experience.
     * Also, refetches the data from the server to reflect the changes.
     */

    const handleWorkExperienceDataChange = () => {
        setExpandedSection({ section: null, index: null });
        fetchData();
    };

    /**
     * Resets the expanded section state to null when the finance data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing the finance data.
     * Also, refetches the data from the server to reflect the changes.
     */
    const handleFinanceDataChange = () => {
        fetchData();
        setExpandedSection({ section: null, index: null });
    };
    /**
     * Resets the expanded section state to null when the certificate data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing a certificate.
     * Also, refetches the data from the server to reflect the changes.
     */
    const handleCertificateDataChange = () => {
        setExpandedSection({ section: null, index: null });
        fetchData();
    };
    /**
     * Updates the summary state with the provided data.
     * Resets the summary to an empty string if no data is provided.
     * @param {Object} data - Object containing the professional summary data.
     */

    const handleSummaryDataChange = (data) => {
        setSummary(data || '');
    };
    /**
     * Resets the expanded section state to null when the custom section data changes.
     * This is used to close the expanded section when the user clicks on the "Save"
     * button after adding or editing a custom section.
     * Also, refetches the data from the server to reflect the changes.
     */
    const handleCustomSectionDataChange = async () => {
        setFlag(false);
        fetchData();
        setExpandedSection({ section: null, index: null });
    };
    /**
     * Handles the expand event of the section accordion. When the section
     * is expanded, it checks if there is any unsaved data in local storage
     * for the corresponding section (education, certificate, work) and if
     * so, it adds the unsaved data to the respective state (educations,
     * certificates, workHistory). If the section is already expanded, it
     * returns a state with section and index set to null, which will close
     * the expanded section.
     * @param {string} section The name of the section (education, certificate, work)
     * @param {number} index The index of the item in the section
     */
    const handleExpand = (section, index) => {
        setExpandedSection((prev) => {
            if (!(prev.section === section && prev.index === index)) {
                if (prev?.section === "education") {
                    const eduUnsavedData = localStorage.getItem("education") ? JSON.parse(localStorage.getItem("education")) : null;
                    setEducationData([...educationData?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
                }
                if (prev?.section === "certificate") {
                    const eduUnsavedData = localStorage.getItem("certificate") ? JSON.parse(localStorage.getItem("certificate")) : null;
                    setCertificate([...certificateData?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
                }
                if (prev?.section === "work") {
                    const eduUnsavedData = localStorage.getItem("workExperience") ? JSON.parse(localStorage.getItem("workExperience")) : null;
                    setWorkHistory([...workExperienceData?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
                }
                return { section, index }
            } else {
                return { section: null, index: null }
            }
        });
    };

    /**
     * Calculates the gaps in the work experience of a candidate and 
     * checks if there are any overlaps with the education or certificate
     * data. If there are overlaps, it adjusts the gaps to exclude the
     * overlapping periods.
     * @param {array} workExperienceList - The list of work experiences
     * @param {array} educationData - The list of educations
     * @param {array} certificateData - The list of certificates
     * @returns {array} The list of gaps in the work experience
     */
    const gapWorkExperience = (workExperienceList, educationData, certificateData) => {

        let gaps = [];
        /**
         * Calculates the difference in days between two dates.
         * @param {Date} startDate - The start date of the period to calculate.
         * @param {Date} endDate - The end date of the period to calculate.
         * @returns {number} The number of days between the start and end dates.
         */

        const calculate = (startDate, endDate) => {
            const timeDifference = startDate - endDate;
            const differenceInHours = Math.floor(timeDifference / (1000 * 60 * 60));
            const differenceInDays = Math.floor(differenceInHours / 24);
            // console.log(differenceInDay);
            return differenceInDays;
        };

        /**
         * Checks if the endDate of the work experience is within the gap period
         * and returns the gap period if it is. If not, it returns an empty object
         * and sets isupdated to true if there is an overlap.
         * @param {number} index - The index of the work experience in the list.
         * @param {Date} startDate - The start date of the work experience.
         * @param {number} gapDays - The number of days in the gap period.
         * @param {boolean} isupdated - Whether there is an overlap or not.
         * @returns {object} The gap period if there is an overlap, otherwise an empty object.
         */
        const checkEndDate = (index, startDate, gapDays, isupdated = false) => {
            let AddGap = {};
            for (let i = index + 1; i < workExperienceList.length; i++) {
                const endDate = new Date(workExperienceList[i].work_history_to);
                let gap = calculate(startDate, endDate);
                if (gap <= gapDays) {
                    gapDays = gap;
                    if (gap >= 87) {
                        const gapStartDate = new Date(startDate);
                        const gapEndDate = new Date(endDate);

                        gapStartDate.setDate(gapStartDate.getDate() - 1);
                        gapEndDate.setDate(gapEndDate.getDate() + 1);
                        AddGap = {
                            endDate: gapStartDate,
                            startDate: gapEndDate,
                        };
                        return { AddGap, isupdated: true };
                    } else {
                        isupdated = true;
                    }
                }
            }
            return { AddGap: {}, isupdated: isupdated };
        }

        if (workExperienceList?.length > 0 && !workExperienceList[0]?.present) {
            const startDate = new Date();

            const now = new Date();
            const isSameMonthAndYear =
                startDate.getMonth() === now.getMonth() &&
                startDate.getFullYear() === now.getFullYear();

            if (isSameMonthAndYear) {
                startDate.setDate(0);
            }

            const endDate = new Date(workExperienceList[0].work_history_to);
            if (calculate(startDate, endDate) >= 87) {
                const gapStartDate = new Date(startDate);
                const gapEndDate = new Date(endDate);

                gapEndDate.setDate(gapEndDate.getDate() + 1);

                gaps.push({
                    endDate: gapStartDate,
                    startDate: gapEndDate,
                });

            }
        }

        if (workExperienceList.length > 1) {
            for (let i = 1; i < workExperienceList.length; i++) {
                const startDate = new Date(workExperienceList[i - 1].work_history_from);
                const endDate = new Date(workExperienceList[i].work_history_to);
                const gapDays = calculate(startDate, endDate);
                let { AddGap, isupdated } = checkEndDate(i, startDate, gapDays);
                if (AddGap?.endDate && AddGap?.startDate) gaps.push(AddGap);
                if (gapDays >= 87 && !isupdated) {
                    const gapStartDate = new Date(startDate);
                    const gapEndDate = new Date(endDate);

                    gapStartDate.setDate(gapStartDate.getDate() - 1);
                    gapEndDate.setDate(gapEndDate.getDate() + 1);

                    gaps.push({
                        endDate: gapStartDate,
                        startDate: gapEndDate,
                    });
                }
            }
        }

        let result
        if (gaps && gaps?.length > 0 && (educationData && educationData?.length > 0 || certificateData && certificateData?.length > 0)) {
            result = adjustGapsForPeriods(gaps, educationData, certificateData);
            gaps = result;
        }
        setGap(gaps);
        return gaps;
    };

    /**
     * Adjusts the gaps in the work experience of a candidate to exclude any
     * periods when they were studying full time. If there is an overlap, it
     * breaks the gap into two parts: the part before the full time study period
     * and the part after the full time study period. If there is no overlap, it
     * adds the gap to the list of adjusted gaps if it is longer than 87 days.
     * @param {array} gaps - The list of gaps in the work experience of a candidate.
     * @param {array} educationData - The list of educations of a candidate.
     * @param {array} certificateData - The list of certificates of a candidate.
     * @returns {array} The list of adjusted gaps in the work experience of a candidate.
     */
    const adjustGapsForPeriods = (gaps, educationData, certificateData) => {
        const combinedData = [...educationData, ...certificateData];
        const filteredData = combinedData.filter(item =>
            item.learning_format === "Full time - offline" || item.learning_format === "Full time - online"
        );

        const periods = filteredData.map(item => ({
            from: new Date(item.education_from),
            to: new Date(item.education_to)
        }));

        const adjustedGaps = [];

        for (const gap of gaps) {
            let gapStart = new Date(gap.startDate);
            let gapEnd = new Date(gap.endDate);

            gapStart.setMonth(gapStart.getMonth());
            gapStart.setDate(1);
            gapEnd = new Date(gapEnd.getFullYear(), gapEnd.getMonth() + 1, 0);

            let hasOverlap = false;

            for (const period of periods) {
                const periodStart = new Date(period.from);
                const periodEnd = new Date(period.to);

                if (gapStart <= periodEnd && gapEnd >= periodStart) {
                    hasOverlap = true;

                    if (gapStart < periodStart) {
                        const beforeGapEnd = new Date(periodStart);
                        beforeGapEnd.setDate(beforeGapEnd.getDate() - 1);
                        const beforeGapDuration = (beforeGapEnd - gapStart) / (1000 * 60 * 60 * 24);
                        if (beforeGapDuration >= 87) {
                            adjustedGaps.push({
                                startDate: new Date(gapStart),
                                endDate: new Date(beforeGapEnd)
                            });
                        }
                    }

                    if (gapEnd > periodEnd) {
                        const afterGapStart = new Date(periodEnd);
                        afterGapStart.setMonth(afterGapStart.getMonth() + 1);
                        afterGapStart.setDate(1);
                        const afterGapDuration = (gapEnd - afterGapStart) / (1000 * 60 * 60 * 24);
                        if (afterGapDuration >= 87) {
                            adjustedGaps.push({
                                startDate: new Date(afterGapStart),
                                endDate: new Date(gapEnd)
                            });
                        }
                    }

                    break;
                }
            }

            if (!hasOverlap) {
                const gapDuration = (gapEnd - gapStart) / (1000 * 60 * 60 * 24);
                if (gapDuration >= 87) {
                    adjustedGaps.push({
                        startDate: new Date(gapStart),
                        endDate: new Date(gapEnd)
                    });
                }
            }
        }

        return adjustedGaps;
    };
    /**
     * Closes the current dialog or modal by setting its open state to false.
     */

    const handleClose = () => {
        setOpen(false);
    };
    /**
     * Validates the user's input and proceeds to the next step
     * if the input is valid. If the input is not valid, it displays
     * an error message.
     * 
     * @returns {Promise<void>}
     */
    const validateAndProceed = async () => {
        try {
            setloads(true);
            const isPersonalDetailValid = await personalDetailRef.current.triggerValidation();
            if (!user?.phone) {
                setContactDetailsError(true);
            } else {
                setContactDetailsError(false);
            }
            if (alignment === "using-existing-resume" && !resume) {
                enqueueSnackbar(`Please upload your resume`, { variant: 'error' });
                return;
            }
            if (user && isPersonalDetailValid && user?.phone && user?.email && educationData && educationData?.length > 0 && workExperienceData && workExperienceData?.length > 0 // && financeTechologiesData && financeTechologiesData?.length > 0
            ) {
                // const gap = gapWorkExperience(workExperienceData?.filter(item => item?._id), educationData, certificateData);
                let filterWithoutReason = [];
                const workGapList = workExperienceData.filter(edu => edu?.organization_name == 'Work Gap');
                if (workGapList?.length > 0) {
                    filterWithoutReason = workGapList.filter(edu => !edu?.gap_explaination || !edu?.gap_title);
                    if (filterWithoutReason?.length > 0) {
                        setGap(filterWithoutReason);
                    }
                }
                if (filterWithoutReason && filterWithoutReason.length > 0 && (alignment === "talent-juntion-style" || profile?.candidate?.is_master_resume)) { //add a condition for upload resume to not show any carrer break
                    setOpen(true);
                } else {
                    if (user?.stages <= 3) {
                        setNextPage(true);
                        try {
                            const response = await updateUser();
                            if (response && response?.data) {
                                updateContext({ stages: response?.data?.stages });
                                updateContext({ stages: 3 });
                            }
                        } catch (error) {
                            console.error(error);
                        } finally {
                            setNextPage(false);
                        }
                    }
                    let resumeTitle = '';
                    if (alignment === "using-existing-resume") resumeTitle = 'Uploaded Resume';
                    else resumeTitle = 'Master Resume';
                    const masterResume = await updateMainResume({ title: resumeTitle });
                    if (masterResume) {
                        if (hasIncompleteSections()) {
                            setOpenIncompleteDialog(true);
                            return;
                        }
                        navigate('/job-preferences');
                    } else {
                        console.error('Failed to update candidate resume.', { variant: 'error' });
                    }
                }
            } else {
                const personalInfo = isPersonalDetailValid ? '' : "personal details";
                const contactInfo = user?.phone && user?.email ? '' : "contact details";
                const education = educationData && educationData?.length > 0 ? '' : "education";
                const workHistory = workExperienceData && workExperienceData?.length > 0 ? '' : "work history";
                const missingFields = [
                    personalInfo,
                    contactInfo,
                    education,
                    workHistory,
                ].filter(field => field !== '');
                if (missingFields?.length > 0) {
                    const missingFieldsString = missingFields?.join(', ')?.replace(/,([^,]*)$/, ' and$1');
                    enqueueSnackbar(`Please complete your ${missingFieldsString}.`, { variant: 'error' });
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setloads(false);
        }
    };
    /**
     * Checks if there are any incomplete sections in the user's resume.
     * Retrieves data from local storage for work experience, education,
     * and certificate sections. Returns true if any of these sections
     * are incomplete or not present; otherwise, returns false.
     * 
     * @returns {boolean} True if any section is incomplete, false otherwise.
     */

    const hasIncompleteSections = () => {
        const getItem = (key) => JSON.parse(localStorage.getItem(key) || 'null');
        return getItem('workExperience') || getItem('education') || getItem('certificate');
    };
    /**
     * Handles the cancel event of the education, certificate, or work section.
     * Retrieves any unsaved data from local storage and adds it to the respective
     * state (educationData, certificateData, or workExperienceData). If there is
     * no unsaved data, it simply returns a state with section and index set to null,
     * which will close the expanded section.
     * @returns {{section: null, index: null}}
     */
    const handleCancelEducation = () => {
        setExpandedSection((prev) => {
            if (prev?.section === "education") {
                const eduUnsavedData = localStorage.getItem("education") ? JSON.parse(localStorage.getItem("education")) : null;
                setEducationData([...educationData?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
            }
            if (prev?.section === "certificate") {
                const eduUnsavedData = localStorage.getItem("certificate") ? JSON.parse(localStorage.getItem("certificate")) : null;
                setCertificate([...certificateData?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
            }
            if (prev?.section === "work") {
                const eduUnsavedData = localStorage.getItem("workExperience") ? JSON.parse(localStorage.getItem("workExperience")) : null;
                setWorkHistory([...workExperienceData?.filter(edu => edu?._id), ...(eduUnsavedData && !checkLocalDataIsEmpty(eduUnsavedData) ? [{ ...eduUnsavedData }] : [])])
            }
            return { section: null, index: null }
        });
    };

    /**
     * Scrolls to a specific child element with the given targetId.
     * If the element exists, it will be scrolled into view smoothly.
     * @param {string} targetId the id of the element to scroll to
     */
    const scrollToChild = (targetId) => {
        if (scrollableContainerRef.current) {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
    };

    /**
     * Opens the LeaveWithoutUpdatingDialog by setting the
     * leaveWihoutUpdatingDialog state to true.
     */
    const handleOpenLeaveWihoutUpdatingDialog = () => {
        setLeaveWihoutUpdatingDialog(true);
    };
    /**
     * Closes the LeaveWithoutUpdatingDialog by setting the
     * leaveWihoutUpdatingDialog state to false.
     */
    const handleCloseLeaveWihoutUpdatingDialog = () => {
        setLeaveWihoutUpdatingDialog(false);
    };

    const { openDialog, closeDialog, dialogLocation } = useBackNavigationDialog();
    const dialogIds = dialogLocation.state?.dialogIds || [];

    const previewResume = dialogIds.includes("previewResume");

    /**
     * Opens the resume preview dialog by setting the previewRsume state to true.
     */
    const handlePreviewResumeOpen = () => {
        // setPreviewRsume(true);
        openDialog('previewResume');
    };

    /**
     * Closes the resume preview dialog by setting the previewRsume state to false.
     */

    const handlePreviewResumeClose = () => {
        // setPreviewRsume(false);
        closeDialog('previewResume');
    };

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center">
                <SplashScreen />
            </Grid>
        );
    }

    return (
        <Box>
            <Box>
                <Container maxWidth="xl" disableGutters>
                    <Grid container>
                        {/* Left Section with Form */}
                        <Grid item xs={12} md={alignment === "using-existing-resume" ? 12 : 7} lg={alignment === "using-existing-resume" ? 12 : 7}>
                            <Box className="candidate-details-content">
                                <Box ref={scrollableContainerRef} className="candidate-det-wrapper" >
                                    <Box mb={3}>
                                        <Box mb={3}>
                                            <Typography className="basic-profile-main-heading" variant="h6" gutterBottom>
                                                {uploadResume ? 'Update ' : 'Create '} Your Master Profile
                                            </Typography>
                                            <Typography className="step-info" variant="body2" gutterBottom>
                                                {uploadResume ? 'Please update relevant fields here' : (alignment === "talent-juntion-style" ? 'These details would help us find most suitable jobs for you' : 'Provide the following details to make sure we bring the best jobs for you')}
                                            </Typography>
                                        </Box>
                                        {!uploadResume && <Box className="resume-type-btn-group">
                                            <ToggleButtonGroup
                                                className="resume-type-toggle-btn"
                                                color="primary"
                                                value={alignment}
                                                exclusive
                                                onChange={handleToggleChange}
                                                aria-label="Platform"
                                                sx={{ gap: '16px' }}
                                            >
                                                <ToggleButton value="using-existing-resume" disableRipple>Using Existing Resume</ToggleButton>
                                                <ToggleButton value="talent-juntion-style" disableRipple>Talent Junction Style</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Box>}
                                    </Box>

                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />

                                    {alignment !== "talent-juntion-style" && <>
                                        <UploadExistingProfile onProfilePhotoChange={handleProfilePhotoChange} setResume={setResume} />
                                        <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                    </>}

                                    <UploadProfile profilephoto={profilephoto} setUpdating={setUpdating} onProfilePhotoChange={handleProfilePhotoChange} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />

                                    <PersonalDetails profileData={profile} ref={personalDetailRef} setUpdating={setUpdating} hideBox={true} alignment={alignment} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />

                                    <ContactDetails contactDetailsError={contactDetailsError} setUpdating={setUpdating} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />

                                    <EducationDetails scrollToChild={scrollToChild} educationData={educationData} setUpdating={setUpdating} onCancel={handleCancelEducation} onEducationDataChange={handleEducationDataChange} expandedSection={expandedSection} handleExpand={handleExpand} certificateData={certificateData} workExperienceData={workExperienceData} uploadResume={alignment === "using-existing-resume" ? true : false} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />

                                    <WorkExperienceDetails scrollToChild={scrollToChild} setUpdating={setUpdating} workExperienceData={workExperienceData} onCancel={handleCancelEducation} onWorkExperienceDataChange={handleWorkExperienceDataChange} expandedSection={expandedSection} handleExpand={handleExpand} certificateData={certificateData} educationData={educationData} uploadResume={alignment === "using-existing-resume" ? true : false} />
                                    {alignment === "using-existing-resume" &&
                                        <TotalWorkExperienceDisplay workExperienceData={workExperienceData} candidateData={profile?.candidate} />
                                    }
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />

                                    <FinanceTechnicalCompetencies financeTechologiesData={financeTechologiesData} setUpdating={setUpdating} onFinanceDataChange={handleFinanceDataChange} />
                                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0' }} />

                                    {alignment === "talent-juntion-style" && (
                                        <>
                                            <CertificationSection scrollToChild={scrollToChild} setUpdating={setUpdating} certificateData={certificateData} onCancel={handleCancelEducation} onCertificateDataChange={handleCertificateDataChange} expandedSection={expandedSection} handleExpand={handleExpand} educationData={educationData} workExperienceData={workExperienceData} />
                                            <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0' }} />

                                            <ProfessionalSummary summaryData={summaryData} setUpdating={setUpdating} onSummaryDataChange={handleSummaryDataChange} handleExpand={() => { setExpandedSection({ section: null, index: null }); }} />
                                            <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0' }} />

                                            <CustomSection customSectionData={customSection} flag={flag} setUpdating={setUpdating} onCustomDataChange={handleCustomSectionDataChange} />
                                            <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0' }} />

                                            <Disability profileData={profile} setUpdating={setUpdating} />
                                            <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', margin: '1.5rem 0;' }} />
                                        </>
                                    )}

                                    {(uploadResume || createNewResume) ?
                                        <Box className="form-action-btn" sx={{ display: { xs: 'none', md: 'block' } }}>
                                            <Stack direction="row" spacing={{ xs: 0, md: 2 }} mt={{ xs: 0, md: 3 }}>
                                                <Button fullwidth sx={{ width: { xs: '100%', sm: 'auto' } }} onClick={handleOpenLeaveWihoutUpdatingDialog} className="text-button" size="medium" disableRipple disableElevation>Cancel</Button>
                                                <Button
                                                    fullWidth
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '8px',
                                                        whiteSpace: 'nowrap',
                                                        width: { xs: '100%', sm: 'auto' },
                                                        backgroundColor: '#1575c6',
                                                        borderRadius: '12px',
                                                        padding: '10px'
                                                    }}
                                                    variant="contained"
                                                    className="nxt-btn"
                                                    onClick={() => validateAndProceed()}
                                                    disabled={loads}
                                                >
                                                    {loads ? (createNewResume ? 'Creating...' : 'Updating...') : (createNewResume ? 'Create Resume' : 'Update Resume')}
                                                </Button>
                                            </Stack>
                                        </Box> :
                                        <Button sx={{ display: { xs: 'none', md: 'block' } }} className='next-btn' variant="contained" size="large" disableRipple disableElevation onClick={validateAndProceed} disabled={nextPage}>
                                            Next
                                        </Button>
                                    }
                                    {/* Career breaks drawer mobile view */}
                                    {isMobile ?
                                        <Drawer
                                            anchor="bottom"
                                            open={open}
                                            onClose={handleClose}
                                            className="forgot-password-dialog career-breaks-dialog"
                                        >
                                            <CareerBreaksIdentifiedDialog gap={workExperienceGap} onClose={handleClose} onWorkExperienceDataChange={handleWorkExperienceDataChange} />
                                        </Drawer> :
                                        <Dialog
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                            className="career-breaks-dialog"
                                        >
                                            <CareerBreaksIdentifiedDialog gap={workExperienceGap} onClose={handleClose} onWorkExperienceDataChange={handleWorkExperienceDataChange} />
                                        </Dialog>}
                                    {(uploadResume || createNewResume) ?
                                        <Box className="form-action-btn" sx={{ display: { xs: 'block', md: 'none' } }}>
                                            <Stack direction="row" spacing={{ xs: 0, md: 2 }} mt={{ xs: 0, md: 3 }}>
                                                <Button fullwidth sx={{ width: { xs: '100%', sm: 'auto' } }} onClick={handleOpenLeaveWihoutUpdatingDialog} className="text-button" size="medium" disableRipple disableElevation>Cancel</Button>
                                                <Button
                                                    fullWidth
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '8px',
                                                        whiteSpace: 'nowrap',
                                                        width: { xs: '100%', sm: 'auto' },
                                                        backgroundColor: '#1575c6',
                                                        borderRadius: '12px',
                                                        padding: '10px'
                                                    }}
                                                    variant="contained"
                                                    className="nxt-btn"
                                                    onClick={() => validateAndProceed()}
                                                    disabled={loads}
                                                >
                                                    {loads ? (createNewResume ? 'Creating...' : 'Updating...') : (createNewResume ? 'Create Resume' : 'Update Resume')}
                                                </Button>
                                            </Stack>
                                        </Box> :
                                        <Box className="form-action-btn" sx={{ display: { xs: 'block', md: 'none' } }}>
                                            <Stack direction="row" spacing={{ xs: 0, md: 2 }} mt={{ xs: 0, md: 3 }}>
                                                <Button className='next-btn' fullWidth sx={{ display: { xs: 'block', md: 'none' } }} variant="contained" size="large" disableRipple disableElevation onClick={validateAndProceed} disabled={nextPage}>
                                                    Next
                                                </Button>
                                            </Stack>
                                        </Box>}

                                    {alignment === "talent-juntion-style" && (
                                        showFirstButton ?
                                            <Box className='pre-resume-full-btn-block' sx={{ display: { xs: 'flex', md: 'none' } }} mb={1}>
                                                <Button disableRipple variant="contained" endIcon={
                                                    <SvgIcon sx={{ margin: 0 }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7554 2.26088C10.6311 2.1352 10.5611 1.96605 10.5611 1.78942V0.17393L12.8547 2.46053H11.227C11.0497 2.45918 10.8804 2.38723 10.7554 2.26088ZM13.0163 2.78262V15.1671C13.0156 15.6243 12.6467 15.9959 12.1889 16H1.81653C1.35662 15.9993 0.984321 15.6264 0.983643 15.1671V0.832885C0.984322 0.373651 1.3566 0.000678259 1.81653 0H10.2268V1.79478C10.2288 2.34641 10.6751 2.79274 11.2268 2.79478L13.0163 2.78262ZM3.97284 5.13583C3.97284 6.074 4.4083 6.95983 5.15287 7.53183C5.89742 8.10316 6.86551 8.29677 7.77182 8.05424C8.67874 7.81172 9.42128 7.16158 9.78138 6.29407C10.1408 5.42722 10.0769 4.44225 9.60815 3.62904C9.13872 2.81585 8.31874 2.26763 7.38798 2.14466C6.45727 2.02169 5.52242 2.33827 4.85877 3.00199C4.29219 3.57196 3.97698 4.34439 3.98378 5.14808L3.97284 5.13583ZM9.53804 13.6922C9.53804 13.646 9.52038 13.6018 9.48709 13.5692C9.45448 13.5366 9.41032 13.5183 9.36413 13.5183H2.62501C2.5727 13.5019 2.51496 13.5115 2.4708 13.5441C2.42596 13.5767 2.40015 13.629 2.40015 13.684C2.40015 13.7397 2.42596 13.7913 2.4708 13.824C2.51496 13.8572 2.5727 13.8668 2.62501 13.8505H9.38048C9.46336 13.8477 9.53401 13.7866 9.54692 13.7044L9.53804 13.6922ZM11.538 12.2173C11.538 12.1711 11.5204 12.1269 11.4871 12.0943C11.4545 12.0617 11.4103 12.0434 11.3641 12.0434H2.62501C2.5727 12.0278 2.51632 12.0386 2.47216 12.0712C2.42868 12.1038 2.40287 12.1555 2.40287 12.2105C2.40287 12.2649 2.42868 12.3165 2.47216 12.3498C2.51632 12.3824 2.5727 12.3926 2.62501 12.3776H11.3805C11.464 12.3749 11.5347 12.3124 11.5469 12.2295L11.538 12.2173ZM11.538 10.7424C11.538 10.6962 11.5204 10.6521 11.4871 10.6195C11.4545 10.5869 11.4103 10.5685 11.3641 10.5685H2.62501C2.55096 10.5903 2.50001 10.6582 2.50001 10.7356C2.50001 10.8131 2.55096 10.881 2.62501 10.9028H11.3805C11.464 10.9 11.5347 10.8375 11.5469 10.7547L11.538 10.7424ZM11.538 9.26756C11.538 9.22137 11.5204 9.17721 11.4871 9.1446C11.4545 9.11199 11.4103 9.09365 11.3641 9.09365H2.62501C2.55096 9.11539 2.50001 9.18332 2.50001 9.26077C2.50001 9.33821 2.55096 9.40615 2.62501 9.42789H11.3805C11.464 9.42517 11.5347 9.36335 11.5469 9.27979L11.538 9.26756ZM4.91718 6.83279H4.91786C4.48511 6.30562 4.26976 5.63442 4.31459 4.95366C4.35943 4.27363 4.66106 3.63641 5.15903 3.17036C5.65631 2.70432 6.31255 2.44549 6.99398 2.44549C7.67605 2.44549 8.33161 2.70432 8.82963 3.17036C9.32691 3.63639 9.62855 4.27363 9.67338 4.95366C9.71822 5.63437 9.50286 6.30555 9.07081 6.83279C8.94105 6.45167 8.70737 6.11404 8.39622 5.85927C7.99676 5.55425 7.50492 5.39595 7.00288 5.41023C6.49541 5.39936 6.00017 5.56512 5.60139 5.8783C5.29024 6.13374 5.05656 6.47068 4.92612 6.85181L4.91718 6.83279ZM5.85468 4.13923C5.85536 4.68745 6.24259 5.15961 6.78062 5.26627C7.31866 5.37293 7.85738 5.08488 8.06662 4.57809C8.27653 4.07062 8.09855 3.48639 7.64203 3.18205C7.18551 2.8777 6.57817 2.93885 6.19026 3.32675C5.9749 3.5421 5.854 3.8342 5.85468 4.13923ZM7.00278 4.95309C7.39205 4.95309 7.72697 4.67863 7.80305 4.29684C7.87914 3.91505 7.67466 3.53258 7.31528 3.3838C6.95523 3.23502 6.54083 3.3607 6.3248 3.68476C6.10876 4.00881 6.15156 4.4395 6.42738 4.71465C6.57955 4.86818 6.78674 4.95376 7.00278 4.95309ZM8.19571 6.13719C7.85605 5.8702 7.43485 5.72957 7.00278 5.73908C6.14137 5.70308 5.37847 6.28936 5.19026 7.13038C5.68619 7.58216 6.33224 7.83284 7.00278 7.83284C7.67331 7.83284 8.31935 7.58216 8.81529 7.13038C8.72155 6.74112 8.50481 6.39261 8.19571 6.13719Z" fill="white" />
                                                        </svg>
                                                    </SvgIcon>
                                                } onClick={handlePreviewResumeOpen}>
                                                    Preview Resume
                                                </Button>
                                            </Box> :
                                            <Box className='pre-resume-btn-block' sx={{ display: { xs: 'flex', md: 'none' } }} mb={1}>
                                                <IconButton aria-label="delete" onClick={handlePreviewResumeOpen}>
                                                    <SvgIcon sx={{ width: '12px', height: '16px' }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7554 2.26088C10.6311 2.1352 10.5611 1.96605 10.5611 1.78942V0.17393L12.8547 2.46053H11.227C11.0497 2.45918 10.8804 2.38723 10.7554 2.26088ZM13.0163 2.78262V15.1671C13.0156 15.6243 12.6467 15.9959 12.1889 16H1.81653C1.35662 15.9993 0.984321 15.6264 0.983643 15.1671V0.832885C0.984322 0.373651 1.3566 0.000678259 1.81653 0H10.2268V1.79478C10.2288 2.34641 10.6751 2.79274 11.2268 2.79478L13.0163 2.78262ZM3.97284 5.13583C3.97284 6.074 4.4083 6.95983 5.15287 7.53183C5.89742 8.10316 6.86551 8.29677 7.77182 8.05424C8.67874 7.81172 9.42128 7.16158 9.78138 6.29407C10.1408 5.42722 10.0769 4.44225 9.60815 3.62904C9.13872 2.81585 8.31874 2.26763 7.38798 2.14466C6.45727 2.02169 5.52242 2.33827 4.85877 3.00199C4.29219 3.57196 3.97698 4.34439 3.98378 5.14808L3.97284 5.13583ZM9.53804 13.6922C9.53804 13.646 9.52038 13.6018 9.48709 13.5692C9.45448 13.5366 9.41032 13.5183 9.36413 13.5183H2.62501C2.5727 13.5019 2.51496 13.5115 2.4708 13.5441C2.42596 13.5767 2.40015 13.629 2.40015 13.684C2.40015 13.7397 2.42596 13.7913 2.4708 13.824C2.51496 13.8572 2.5727 13.8668 2.62501 13.8505H9.38048C9.46336 13.8477 9.53401 13.7866 9.54692 13.7044L9.53804 13.6922ZM11.538 12.2173C11.538 12.1711 11.5204 12.1269 11.4871 12.0943C11.4545 12.0617 11.4103 12.0434 11.3641 12.0434H2.62501C2.5727 12.0278 2.51632 12.0386 2.47216 12.0712C2.42868 12.1038 2.40287 12.1555 2.40287 12.2105C2.40287 12.2649 2.42868 12.3165 2.47216 12.3498C2.51632 12.3824 2.5727 12.3926 2.62501 12.3776H11.3805C11.464 12.3749 11.5347 12.3124 11.5469 12.2295L11.538 12.2173ZM11.538 10.7424C11.538 10.6962 11.5204 10.6521 11.4871 10.6195C11.4545 10.5869 11.4103 10.5685 11.3641 10.5685H2.62501C2.55096 10.5903 2.50001 10.6582 2.50001 10.7356C2.50001 10.8131 2.55096 10.881 2.62501 10.9028H11.3805C11.464 10.9 11.5347 10.8375 11.5469 10.7547L11.538 10.7424ZM11.538 9.26756C11.538 9.22137 11.5204 9.17721 11.4871 9.1446C11.4545 9.11199 11.4103 9.09365 11.3641 9.09365H2.62501C2.55096 9.11539 2.50001 9.18332 2.50001 9.26077C2.50001 9.33821 2.55096 9.40615 2.62501 9.42789H11.3805C11.464 9.42517 11.5347 9.36335 11.5469 9.27979L11.538 9.26756ZM4.91718 6.83279H4.91786C4.48511 6.30562 4.26976 5.63442 4.31459 4.95366C4.35943 4.27363 4.66106 3.63641 5.15903 3.17036C5.65631 2.70432 6.31255 2.44549 6.99398 2.44549C7.67605 2.44549 8.33161 2.70432 8.82963 3.17036C9.32691 3.63639 9.62855 4.27363 9.67338 4.95366C9.71822 5.63437 9.50286 6.30555 9.07081 6.83279C8.94105 6.45167 8.70737 6.11404 8.39622 5.85927C7.99676 5.55425 7.50492 5.39595 7.00288 5.41023C6.49541 5.39936 6.00017 5.56512 5.60139 5.8783C5.29024 6.13374 5.05656 6.47068 4.92612 6.85181L4.91718 6.83279ZM5.85468 4.13923C5.85536 4.68745 6.24259 5.15961 6.78062 5.26627C7.31866 5.37293 7.85738 5.08488 8.06662 4.57809C8.27653 4.07062 8.09855 3.48639 7.64203 3.18205C7.18551 2.8777 6.57817 2.93885 6.19026 3.32675C5.9749 3.5421 5.854 3.8342 5.85468 4.13923ZM7.00278 4.95309C7.39205 4.95309 7.72697 4.67863 7.80305 4.29684C7.87914 3.91505 7.67466 3.53258 7.31528 3.3838C6.95523 3.23502 6.54083 3.3607 6.3248 3.68476C6.10876 4.00881 6.15156 4.4395 6.42738 4.71465C6.57955 4.86818 6.78674 4.95376 7.00278 4.95309ZM8.19571 6.13719C7.85605 5.8702 7.43485 5.72957 7.00278 5.73908C6.14137 5.70308 5.37847 6.28936 5.19026 7.13038C5.68619 7.58216 6.33224 7.83284 7.00278 7.83284C7.67331 7.83284 8.31935 7.58216 8.81529 7.13038C8.72155 6.74112 8.50481 6.39261 8.19571 6.13719Z" fill="white" />
                                                        </svg>
                                                    </SvgIcon>
                                                </IconButton>
                                            </Box>)
                                    }

                                </Box>
                            </Box>
                        </Grid>
                        {/* Resume Section - Moved Outside of regi-upload-page-content */}
                        {alignment === "talent-juntion-style" && (
                            <Grid item md={4} lg={3.5} sx={{ display: { xs: 'none', md: 'block' } }}>
                                <CandidateResume
                                    updating={updating}
                                    setUpdating={setUpdating}
                                    templateType={templateType}
                                    profile={user}
                                    summaryData={summaryData}
                                    educationData={educationData}
                                    workExperienceData={workExperienceData}
                                    certificateData={certificateData}
                                    financeTechologiesData={financeTechologiesData}
                                    customSection={customSection}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Container>


                {/* Preview Resume Dialog */}
                <Dialog
                    fullScreen
                    open={previewResume}
                    onClose={handlePreviewResumeClose}
                    TransitionComponent={Transition}
                    className='preview-resume-dialog'
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Typography className="preview-resume-title" sx={{ ml: 1, flex: 1 }} variant="h6" component="div">
                                Resume Preview
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handlePreviewResumeClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    {/* Candidate Resume Component */}
                    <CandidateResume
                        updating={updating}
                        setUpdating={setUpdating}
                        templateType={templateType}
                        profile={user}
                        summaryData={summaryData}
                        educationData={educationData}
                        workExperienceData={workExperienceData}
                        certificateData={certificateData}
                        financeTechologiesData={financeTechologiesData}
                        customSection={customSection}
                    />
                </Dialog>
                {/* incomplete dialog */}
                {isMobile ?
                    <Drawer
                        anchor="bottom"
                        open={openIncompleteDialog}
                        onClose={() => setOpenIncompleteDialog(false)}
                        className="forgot-password-dialog otp-dialog-wrapper"
                    >
                        <IncompleteSectionDialog
                            onClose={() => setOpenIncompleteDialog(false)}
                            navigateTo={() => navigate('/job-preferences')} />
                    </Drawer> :
                    <Dialog
                        open={openIncompleteDialog}
                        onClose={() => setOpenIncompleteDialog(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        className="otp-dialog-wrapper"
                    >
                        <IncompleteSectionDialog
                            onClose={() => setOpenIncompleteDialog(false)}
                            navigateTo={() => navigate('/job-preferences')} />
                    </Dialog>}
            </Box>
            {/* Leave without updating changes dialog */}
            {isMobile ?
                <Drawer
                    anchor="bottom"
                    open={withoutUpdateDialog}
                    onClose={handleCloseLeaveWihoutUpdatingDialog}
                    className="forgot-password-dialog career-breaks-dialog"
                >
                    <LeaveWithoutUpdatingDialog updateResume={validateAndProceed} handleClose={handleCloseLeaveWihoutUpdatingDialog} />
                </Drawer> :
                <Dialog
                    open={withoutUpdateDialog}
                    onClose={handleCloseLeaveWihoutUpdatingDialog}
                    className="action-dialog-card"
                >
                    <LeaveWithoutUpdatingDialog updateResume={validateAndProceed} handleClose={handleCloseLeaveWihoutUpdatingDialog} />
                </Dialog>}
        </Box >
    );


}

export default RegistrationUploadResume;
